import {IMediaChecks} from "../../services/media-query/media-queries.interface";
import {
    ICardNetworkIconOptions
} from "../../services/booking/models/payment/methods/card/networks/card-network.view-model.interface";

interface LogoSize {
    width: number;
    height: number;
}

export function computePaymentMethodIconSize(mediaQuery: IMediaChecks, options: ICardNetworkIconOptions): LogoSize {
    const originalWidth = options.preferredOriginalSize?.width ?? 91;
    const originalHeight = options.preferredOriginalSize?.height ?? 60;

    if(options.useSmallIcon) {
        return {
            width: originalWidth * 0.4,
            height: originalHeight * 0.4
        }
    }

    if(mediaQuery.xsAndBelow) {
        return {
            width: originalWidth * 0.65,
            height: originalHeight * 0.65
        }
    }

    return {
        width: originalWidth,
        height: originalHeight
    };
}